export const PLAN_COMPARISON_URL = 'https://www.completehomewarranty.com/warranty-plans/#plansTab-0'
export const TERMS_AND_CONDITIONS_URL = 'https://www.completehomewarranty.com/wp-content/uploads/2022/03/TC2022.pdf'
